import React, { Component } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { strings } from '../resources/strings';
import { ContactCommand } from './commands/ContactCommand';
import { LinkContainer } from 'react-router-bootstrap';

export class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            commands: {
                contacts: new ContactCommand()
            },
            sending: false,
            result: undefined
        };
    }

    sendMail = (e) => {
        e.preventDefault();

        this.setState({ sending: true });
        this.state.commands.contacts.sendEmail({
            name: e.target.name.value,
            email: e.target.email.value,
            subject: `${e.target.subjectType.value} - ${e.target.subject.value}`,
            message: e.target.message.value
        }, (r) => this.sendSuccessCallback(r), (r) => this.sendErrorCallback(r));
    }

    sendSuccessCallback(result) {
        this.setState({
            sending: false,
            result: true
        });
    }

    sendErrorCallback(result) {
        this.setState({
            sending: false,
            result: false
        });
    }

    onCheckboxChange() {
        const { sending } = this.state;
        this.setState({
            sending: !sending,
        });
    }

    render() {
        const subjectOptions = [strings.contactComplaints, strings.contactLostAndFound, strings.contactInformationRequest];

        return (
            <Container fluid className="mb-5" >
                <Row>
                    <Col lg={4}>
                        <Form onSubmit={this.sendMail} className="mb-3">
                            <div class="mt-3">
                                <h3>{strings.contactUs}</h3>
                            </div>

                            <Form.Group className="mb-3" controlId="name">
                                <Form.Control className="contact-input" required placeholder={strings.name} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="email">
                                <Form.Control type="email" className="contact-input" required placeholder={strings.email} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="subjectType">
                                <Form.Select className="contact-input" aria-label={strings.subject}>
                                    {
                                        subjectOptions.map((option, index) =>
                                            <option key={option} value={option}>{option}</option>
                                        )
                                    }

                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="subject">
                                <Form.Control className="contact-input" required placeholder={strings.subject} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="message">
                                <Form.Control as="textarea" rows={5} className="contact-input" required placeholder={strings.message} />
                            </Form.Group>

                            <Button variant="primary" type="submit" disabled={!this.state.sending}>
                                {strings.send}
                            </Button>

                            <Form.Group>
                                <br />
                                <Form.Check
                                    checked={this.state.sending}
                                    onChange={() => this.onCheckboxChange()}
                                    label={
                                        <span>
                                            <span dangerouslySetInnerHTML={{ __html: strings.contactsPrivacyCheckboxBefore }} />
                                            <LinkContainer to="/privacypolicy"><a>{strings.contactsPrivacyCheckboxLinkText}</a></LinkContainer>
                                            <span dangerouslySetInnerHTML={{ __html: strings.contactsPrivacyCheckboxAfter }} />
                                        </span>
                                    }
                                />
                                <Form.Text className="text-muted">
                                    <p>
                                        <span dangerouslySetInnerHTML={{ __html: strings.contactsPrivacyInfoBefore }} />
                                        <LinkContainer to="/privacypolicy"><a>{strings.contactsPrivacyInfoLinkText}</a></LinkContainer>
                                        <span dangerouslySetInnerHTML={{ __html: strings.contactsPrivacyInfoAfter }} />
                                    </p>
                                </Form.Text>
                                <br />
                            </Form.Group>

                            {this.state.result !== undefined
                                ? <Alert className="mt-3" variant={this.state.result ? "success" : "danger"}>
                                    {this.state.result
                                        ? strings.emailSuccess
                                        : strings.emailError}
                                </Alert>
                                : null}
                        </Form>
                    </Col>
                </Row>
                <Row>
                    <Col className="mt-5">
                        <div>
                            <h4><b>{strings.vizurContactName}</b></h4>
                            <p>{strings.vizurContactDescription}</p>
                            <p><a href='https://www.vamusalgarve.pt' target='_blank' rel='noopener noreferrer'>{strings.vizurWebsite}</a></p>
                            <p>{strings.vizurAddress}</p>
                            <p>{strings.vizurContact}</p>
                            <p>{strings.vizurEmail}</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}